/** Business-dialect overrides: only the strings that name a matter or its unbilled work. Sparse. */
export const hub = {
    breadcrumbs: {
        matterFallback: 'Project',
    },
    deletedBanner: {
        matter: 'This project was deleted. Its time, invoices and other records are kept.',
    },
    figures: {
        wip: 'Unbilled work',
    },
    matters: {
        statusFilterLabel: 'Filter projects by status',
        columnWip: 'Unbilled',
        loadError: "Couldn't load projects",
    },
    matterStatement: {
        breadcrumb: 'Project statement',
        empty: 'Nothing on this project in this period.',
        loadError: "Couldn't load this project's statement.",
        unpaidInvoicesLoadError: "Couldn't load this project's unpaid invoices.",
    },
    clientStatementMatter: {
        matterDueByClient: 'Due by client for this project',
        matterDueToClient: 'Due to client for this project',
        noUnpaidInvoices: 'No unpaid invoices on this project',
    },
    header: {
        matterActions: 'Project actions',
        matterStatement: 'Project statement',
    },
    timeline: {
        badge: {
            noMatter: 'No project',
        },
    },
    switcher: {
        trigger: 'Switch project: {{name}}',
        allMatters: 'All projects',
        optionDetail: '{{reference}} · Unbilled {{amount}}',
    },
};
